module.exports = __webpack_public_path__ + "static/media/Playlist info (Active).a785ea06.svg";